<label *transloco="let t">
  <span class="flex">
    <span
      class="{{labelClasses}} {{required ? requiredClasses : ''}}"
      [ngClass]="{ disabled: isDisabled }">
    {{label}}
    </span>
    <psc-info-icon [iconColorClass]="infoIconColorClass" [infoText]="infoText"
                   [sizeInPx]="infoIconSize"></psc-info-icon>
    <psc-loader
      class="ml-[6px] overflow-hidden"
      [size]="'tiny'"
      *ngIf="loading"></psc-loader>
  </span>
  <select class="{{inputClasses}} text-ellipsis h-[58px]"
          [disabled]="isDisabled"
          [ngModel]="value"
          [ngClass]="{'bg-gray-100 text-gray-600': isDisabled}"
          (ngModelChange)="onModelChange($event)">
    <option value="">{{ placeholder || t('placeholders.select_input') }}</option>
    <option
      *ngFor="let option of options"
      [value]="option.value">
      <i *ngIf="option.icon" class="pvsc-icon icon-{{option.icon}} text-[16px]"></i>
      {{option.label}}
    </option>
  </select>

  <psc-input-error
    [control]="formControl"></psc-input-error>
</label>
